import { selectForethoughtLiveChatWidgetComponent } from 'reducers/workflows';
import type { DeploymentConfiguration } from './types';
import {
  selectChatId,
  selectLiveChatJwt,
  setLiveChatId,
  setLiveChatJwt,
} from 'reducers/live-chat';
import { getStore } from 'storeRef';

function getOrganizationId() {
  const forethoughtLiveChatWidgetComponent =
    selectForethoughtLiveChatWidgetComponent(getStore().getState());

  if (
    forethoughtLiveChatWidgetComponent?.component_fields.integration_config
      .integration === 'salesforce'
  ) {
    return forethoughtLiveChatWidgetComponent?.component_fields
      .integration_config.integration_fields.organization_id;
  }

  return '';
}

function getDeploymentDeveloperName() {
  const forethoughtLiveChatWidgetComponent =
    selectForethoughtLiveChatWidgetComponent(getStore().getState());

  if (
    forethoughtLiveChatWidgetComponent?.component_fields.integration_config
      .integration === 'salesforce'
  ) {
    return forethoughtLiveChatWidgetComponent?.component_fields
      .integration_config.integration_fields.developer_name;
  }

  return '';
}

function getSalesforceMessagingUrl() {
  const forethoughtLiveChatWidgetComponent =
    selectForethoughtLiveChatWidgetComponent(getStore().getState());

  if (
    forethoughtLiveChatWidgetComponent?.component_fields.integration_config
      .integration === 'salesforce'
  ) {
    return forethoughtLiveChatWidgetComponent?.component_fields
      .integration_config.integration_fields.scrt_url;
  }

  return '';
}

function setJwt(newJwt: string) {
  getStore().dispatch(setLiveChatJwt(newJwt));
}

function getJwt() {
  return selectLiveChatJwt(getStore().getState());
}

let configuration: DeploymentConfiguration | undefined;
function setDeploymentConfiguration(newConfiguration: DeploymentConfiguration) {
  configuration = newConfiguration;
}
function getDeploymentConfiguration(): DeploymentConfiguration | undefined {
  return configuration;
}

// Store the latest last-event-id from the Access Token API response or from an Event Source (SSE) event in-memory.
let lastEventId: string | undefined;
function setLastEventId(id: string) {
  lastEventId = id;
}
function getLastEventId() {
  return lastEventId;
}

function storeConversationId(convId: string) {
  getStore().dispatch(setLiveChatId(convId));
}
function getConversationId() {
  return selectChatId(getStore().getState());
}

// Clears the in-memory messaging data variables.
function clearInMemoryData() {
  lastEventId = undefined;
}

export const clearWebStorage = () => {
  configuration = undefined;
};

export {
  getOrganizationId,
  getDeploymentDeveloperName,
  getSalesforceMessagingUrl,
  setDeploymentConfiguration,
  getDeploymentConfiguration,
  setLastEventId,
  getLastEventId,
  setJwt,
  getJwt,
  storeConversationId,
  getConversationId,
  clearInMemoryData,
};
